import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";
import { PaginatedResponse } from "@/shared/http";

import { SecretRecord } from "../SecretRecord";

export const getQueryKey = (queryKeyParams?: {
  orgId: string;
  pageSize: number;
  nextToken?: string;
}) => {
  if (queryKeyParams === undefined) {
    return ["orgSecrets"];
  }

  return [
    "orgSecrets",
    queryKeyParams.orgId,
    queryKeyParams.pageSize,
    queryKeyParams?.nextToken,
  ];
};

export function useOrgSecrets(
  orgId: string,
  pageSize: number,
  nextToken?: string,
) {
  const { secretService } = useDomainServices();

  return useQuery<PaginatedResponse<SecretRecord>, Error>({
    queryKey: getQueryKey({ orgId, pageSize, nextToken }),
    queryFn: ({ signal }) => {
      return secretService.getSecretsForOrg(orgId, pageSize, nextToken, {
        abortSignal: signal,
      });
    },
  });
}
